import { render } from "./PlaybookLandingCatalog.vue?vue&type=template&id=40551623"
import script from "./PlaybookLandingCatalog.vue?vue&type=script&lang=js"
export * from "./PlaybookLandingCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/PlaybookLandingCatalog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40551623"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40551623', __exports__)) {
    api.reload('40551623', __exports__)
  }
  
  module.hot.accept("./PlaybookLandingCatalog.vue?vue&type=template&id=40551623", () => {
    api.rerender('40551623', render)
  })

}


export default __exports__